import store from "@/store";
import _ from "lodash";

export default (to, from, next) => {
  if (!_.get(store, "getters.getToken", null)) {
    store.dispatch("signOut");
    next("/auth/sign-in");
  }

  next();
};
